import vcImagePlaceholder from './components/vc-image-placeholder/vc-image-placeholder'

export default vcImagePlaceholder



// WEBPACK FOOTER //
// ./src/lib.js